/**
 * Converts URLs in the text into clickable links while handling edge cases.
 * @param {string | null | undefined} text - The text to parse.
 * @returns {React.ReactNode} - A React fragment with clickable links.
 */
export const parseTextWithLinks = (text: string | null | undefined): React.ReactNode => {
    if (!text) return <></>;

    const urlRegex = /(https?:\/\/[^\s.,!?]+[^\s]*[^\s.,!?])/g;

    const parts = text.split(urlRegex);

    return (
        <>
            {parts.map((part, index) =>
                part.startsWith('http') ? (
                    <a key={index} href={part} target="_blank" rel="noopener noreferrer">
                        {part}
                    </a>
                ) : (
                    part
                )
            )}
        </>
    );
};
